// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__DL4tG","popup":"Popup_popup__BJN-F","close":"Popup_close__DdD+M","content":"Popup_content__zuFTO"};